import { createFileRoute } from "@tanstack/react-router";

import { StoreDetail } from "@/founder/stores/StoreDetail";

export const Route = createFileRoute("/founder/stores/$storeId")({
    component: StoreDetail,
});
